import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function PublicFooter({ className = "" }) {
  return (
    <footer className={`border-t border-border py-8 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col lg:flex-row items-center lg:justify-between gap-6 text-sm text-muted-foreground">
        <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 text-center">
          <Logo className="h-7" />
          <span>Create. Customize. Connect.</span>
        </div>
        <div className="grid grid-cols-2 gap-x-5 gap-y-3 w-full text-center sm:flex sm:w-auto sm:flex-wrap sm:justify-center lg:justify-end">
          <Link to="/contact">Contact Us</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/examples">Examples</Link>
          <Link to="/help">Help</Link>
          <Link to="/blog">Blogs</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
}
